const animateTeam = () => {
  const leafyTeam = document.getElementById('leafy-team');

  if (leafyTeam) {
    // Start the line drawing
    setTimeout(() => {
      leafyTeam.classList.add('start');
      setTimeout(() => {
        // Signal the end of the drawing to start the fill color animation
        leafyTeam.classList.add('finished');
      }, 2500);
    }, 10);
  }
};

const deAnimateTeam = () => {
  const leafyTeam = document.getElementById('leafy-team');

  if (leafyTeam) {
    leafyTeam.classList.remove('start');
    leafyTeam.classList.remove('finished');
  }
};

const animateServices = () => {
  const serviceImages = document.getElementsByClassName('service-images');
  Array.prototype.forEach.call(serviceImages,
    (serviceImage) => { serviceImage.classList.add('start'); }
  );
};

const deAnimateServices = () => {
  const serviceImages = document.getElementsByClassName('service-images');
  Array.prototype.forEach.call(serviceImages,
    (serviceImage) => { serviceImage.classList.remove('start'); }
  );
};

const animateFlowerPot = () => {
  const flowerPotElement = document.getElementById('flower-pot');

  flowerPotElement.classList.add('start');
};

const deAnimateFlowerPot = () => {
  const flowerPotElement = document.getElementById('flower-pot');

  flowerPotElement.classList.remove('start');
};

const animateWorkForUsTeam = () => {
  const teamTopLine = document.getElementById('team-top-line');
  teamTopLine.classList.add('draw');

  const teamBottomLine = document.getElementById('team-bottom-line');
  teamBottomLine.classList.add('draw');

  setTimeout(() => {
    const chairElements = document.getElementsByClassName('work-with-us-chair');
    Array.prototype.forEach.call(chairElements, (chair) => { chair.classList.add('visible'); });
  }, 1400);
};

const deAnimateWorkForUsTeam = () => {
  const teamTopLine = document.getElementById('team-top-line');
  teamTopLine.classList.remove('draw');

  const teamBottomLine = document.getElementById('team-bottom-line');
  teamBottomLine.classList.remove('draw');

  const chairElements = document.getElementsByClassName('work-with-us-chair');
  Array.prototype.forEach.call(chairElements, (chair) => { chair.classList.remove('visible'); });
};

export const onSlideAnimations = (swiper) => {
  if (swiper.activeIndex === 0) {
    animateTeam();
  } else {
    deAnimateTeam();
  }

  if (swiper.activeIndex === 1) {
    animateServices();
  } else {
    deAnimateServices();
  }

  if (swiper.activeIndex === 5) {
    animateFlowerPot();
  } else {
    deAnimateFlowerPot();
  }

  if (swiper.activeIndex === 6) {
    animateWorkForUsTeam();
  } else {
    deAnimateWorkForUsTeam();
  }
};



// WEBPACK FOOTER //
// ./src/App/helpers.js